// Consent model (Vahid ruling 2026-08-06): the banner shows ONLY in
// GDPR-consent jurisdictions; everyone else tracks by default with the
// dismissible notice. Detection is by IANA timezone prefix:
//   Europe/   — EEA + UK + CH (also catches Russia/Turkey/Ukraine etc.;
//               overblocking non-GDPR Europe is accepted, not ICP)
//   Atlantic/ — Azores, Canaries, Madeira, Reykjavik, Faroe (EEA-adjacent)
//   Etc/, UTC, empty — no usable signal, fail safe to the banner
// Known accepted risk (ruled): Canada (PIPEDA/Law 25) and Brazil (LGPD) track
// by default; the DPIA from the dark-stack architecture doc remains open.
// Keep in sync with the inline copy in index.html; geo.test.ts enforces parity.
export const BANNER_TZ_REGEX_SOURCE = '^(Europe\\/|Atlantic\\/|Etc\\/|UTC$)';

const BANNER_TZ_REGEX = new RegExp(BANNER_TZ_REGEX_SOURCE);

function resolveTz(): string {
  // Dev-only override so both consent paths can be exercised locally:
  // http://localhost:8080/?tz=Europe/Berlin
  if (import.meta.env.DEV) {
    const override = new URLSearchParams(window.location.search).get('tz');
    if (override) return override;
  }
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

/** True = show the consent banner and hold trackers until accept. */
export function requiresConsentBanner(tz: string = resolveTz()): boolean {
  if (!tz) return true;
  return BANNER_TZ_REGEX.test(tz);
}
